import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'permissionLevel'
})
export class PermissionLevelPipe implements PipeTransform {

  transform(value: number): any {
    if (value == 1) {
      return "Read Only Permission [1]"
    } else if (value == 2) {
      return "Read & Create Permission [2]"
    } else if (value == 3 || value == 4) {
      return "Read, Create & Modify Permission [3]"
    }
    return "NONE";
  }

}
